import React from "react";

export const Title = ({ children, ...props }) => <h1 {...props}>{children}</h1>;
